import axiosInstance from "./api";

const BASE_URL = "/api/custom_pronunciations/";

export const customPronunciationService = {
  async getAll() {
    const result = await axiosInstance.get(`${BASE_URL}`);
    if (result.status !== 200) {
      console.error("Error fetching custom pronunciations:", result);
      throw new Error(
        result.data?.error || "Failed to fetch custom pronunciations",
      );
    }
    return result?.data?.data || [];
  },

  async create({
                 phrase,
                 encoded_phonetic_pronunciation,
                 phonetic_encoding,
                 simple_phonetic_pronunciation,
                 comment = null,
               }) {
    try {
      const result = await axiosInstance.post(BASE_URL, {
        phrase,
        encoded_phonetic_pronunciation,
        phonetic_encoding,
        simple_phonetic_pronunciation,
        comment,
      });
      if (result.status !== 200 && result.status !== 201) {
        console.error("Error creating custom pronunciation:", result);
        throw new Error(
          result.data?.error || "Failed to create custom pronunciation",
        );
      }
      return result?.data?.data;
    } catch (error) {
      console.error("Error creating custom pronunciation:", error);
      throw new Error(
        error.response?.data?.error || "Failed to create custom pronunciation",
      );
    }
  },

  async bulkCreate({pronunciations}) {
    try {
      const result = await axiosInstance.post(
        `${BASE_URL}bulk`,
        pronunciations,
      );
      if (result.status !== 200 && result.status !== 201) {
        throw new Error(
          result.data?.error || "Failed to bulk create custom pronunciations",
        );
      }
      return result?.data?.data;
    } catch (error) {
      console.error("Error bulk creating custom pronunciations:", error);
      throw new Error(
        error.response?.data?.error ||
        "Failed to bulk create custom pronunciations",
      );
    }
  },

  async update(id, updateData) {
    try {
      const result = await axiosInstance.put(`${BASE_URL}${id}`, updateData);
      if (result.status !== 200 && result.status !== 201) {
        console.error("Error updating custom pronunciation:", result);
        throw new Error(
          result.data?.error || "Failed to update custom pronunciation",
        );
      }
      return result?.data?.data;
    } catch (error) {
      console.error("Error updating custom pronunciation:", error);
      throw new Error(
        error.response?.data?.error || "Failed to update custom pronunciation",
      );
    }
  },

  async delete(id) {
    const result = await axiosInstance.delete(`${BASE_URL}${id}`);
    if (result.status !== 200 && result.status !== 204) {
      console.error("Error deleting custom pronunciation:", result);
      throw new Error(
        result.data?.error || "Failed to delete custom pronunciation",
      );
    }
    return result?.data?.data;
  },

  async validatePronunciations(pronunciations) {
    const result = await axiosInstance.post(
      `${BASE_URL}validate`,
      pronunciations,
    );
    if (result.status !== 200 && result.status !== 201) {
      console.error("Error validating custom pronunciations:", result);
      throw new Error(
        result.data?.error || "Failed to validate custom pronunciations",
      );
    }
    return result?.data?.data;
  },
};

export default customPronunciationService;
